/**
 * Persistence and share links. The board (cities, date, pins) is kept in
 * localStorage, and can be packed into a ?b= URL parameter so a schedule can be
 * sent to someone and opened as-is.
 */
import allCities from '../cities.json';

const byName = new Map(allCities.map((c) => [c.name, c]));
const KEY = 'timepinboard_v2';

export const DEFAULT_CITIES = ['New York', 'London', 'Tokyo'].map((n) => byName.get(n)).filter(Boolean);

export function findCity(name) {
  return byName.get(name) || null;
}

function toCities(names) {
  return (names || []).map((n) => byName.get(n)).filter(Boolean);
}

export function loadBoard() {
  try {
    const packed = new URLSearchParams(window.location.search).get('b');
    if (packed) {
      const b = JSON.parse(decodeURIComponent(escape(atob(packed.replace(/-/g, '+').replace(/_/g, '/')))));
      const cities = toCities(b.c);
      if (cities.length) return { cities, date: b.d || null, pins: b.p || [], fromLink: true };
    }
  } catch (e) { /* bad link: fall through to storage */ }
  try {
    const b = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (b && b.c && b.c.length) return { cities: toCities(b.c), date: null, pins: b.p || [] };
    // migrate the first version's storage
    const old = JSON.parse(localStorage.getItem('timepinboard_cities') || 'null');
    if (old && old.length) {
      const oldPins = JSON.parse(localStorage.getItem('timepinboard_markers') || '[]');
      return {
        cities: toCities(old.map((c) => c.name)),
        date: null,
        pins: oldPins.map((m) => ({ id: m.id, t: m.timestamp, label: m.label, color: 'blue' })),
      };
    }
  } catch (e) { /* storage blocked or corrupt */ }
  return { cities: DEFAULT_CITIES, date: null, pins: [] };
}

export function saveBoard(cities, pins) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ c: cities.map((c) => c.name), p: pins }));
  } catch (e) { /* private mode */ }
}

export function shareUrl(cities, date, pins) {
  const json = JSON.stringify({ c: cities.map((c) => c.name), d: date, p: pins });
  const b = btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return `${window.location.origin}${window.location.pathname}?b=${b}`;
}

export function searchCities(query, exclude, limit = 8) {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const taken = new Set(exclude.map((c) => c.name));
  const scored = [];
  for (const c of allCities) {
    if (taken.has(c.name)) continue;
    const n = c.name.toLowerCase();
    const tz = c.timezone.toLowerCase();
    let s = -1;
    if (n === q) s = 0;
    else if (n.startsWith(q)) s = 1;
    else if (n.split(/[\s-]/).some((w) => w.startsWith(q))) s = 2;
    else if (tz.includes(q.replace(/\s/g, '_'))) s = 3;
    if (s >= 0) scored.push([s, -(c.pop || 0), c]);
  }
  scored.sort((a, b) => a[0] - b[0] || a[1] - b[1]);
  return scored.slice(0, limit).map((x) => x[2]);
}
